webpackJsonp([104248490918402],{

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/drive-america__hero.6fd58bf6.jpg";

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/driveamerica-1.0acc130b.jpg";

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/driveamerica-2.179dbdc9.jpg";

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/driveamerica-3.3fff5ba6.jpg";

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(5);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Header = __webpack_require__(6);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _driveAmerica__hero = __webpack_require__(492);
	
	var _driveAmerica__hero2 = _interopRequireDefault(_driveAmerica__hero);
	
	var _driveamerica = __webpack_require__(493);
	
	var _driveamerica2 = _interopRequireDefault(_driveamerica);
	
	var _driveamerica3 = __webpack_require__(494);
	
	var _driveamerica4 = _interopRequireDefault(_driveamerica3);
	
	var _driveamerica5 = __webpack_require__(495);
	
	var _driveamerica6 = _interopRequireDefault(_driveamerica5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Page = function Page() {
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'DriveAmerica\u2122 | What We Offer'
	      // meta={[{ name: 'description', content: '' }]}
	    }),
	    _react2.default.createElement(
	      _Header2.default,
	      { hero: _driveAmerica__hero2.default },
	      _react2.default.createElement(
	        'h1',
	        { className: 't-hero' },
	        'DriveAmerica\u2122'
	      )
	    ),
	    _react2.default.createElement(
	      'main',
	      { id: 'content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'c-golden t-context--light' },
	        _react2.default.createElement(
	          'div',
	          { className: 'c-golden__images c-golden__short min-laptop' },
	          _react2.default.createElement('img', { src: _driveamerica2.default, alt: '', style: { width: '50%', height: '100%' } }),
	          _react2.default.createElement('img', { src: _driveamerica4.default, alt: '', style: { width: '50%', height: '50%' } }),
	          _react2.default.createElement('img', { src: _driveamerica6.default, alt: '', style: { width: '50%', height: '50%' } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'c-golden__content c-golden__wide' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'c-breadcrumbs mb30' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/' },
	                'Home'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/what-we-offer' },
	                'What We Offer'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                {
	                  to: '/what-we-offer/drive-america',
	                  activeClassName: 'is-active'
	                },
	                'DriveAmerica\u2122'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'c-golden__text' },
	            _react2.default.createElement(
	              'div',
	              { className: 'c-golden__text-col' },
	              _react2.default.createElement(
	                'h1',
	                { className: 't-h1' },
	                'Nothing defines the American spirit like the call of the open road'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 't-p t-p-light mt30' },
	                'ATI\u2019s DriveAmerica\u2122 self-drive tours deliver inspired itineraries, door to door driving instructions with local attraction and activity information along the route, and guaranteed hotel accommodations throughout your entire trip.'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 't-p t-p-light mt30' },
	                'Our flexible booking system allows for you to either customize your very own road trip from scratch or to utilize and make your desired changes to one of our many recommended DriveAmerica\u2122 itineraries. The only thing you need is the spirit of adventure!'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Page;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-what-we-offer-drive-america-js-f52fcbc65275dc6742f5.js